import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (this.getData('duplicate') != null) this.repeatDom()
        this.addTicker = () => this.translate()
        gsap.ticker.add(this.addTicker)
    }

    translate() {
        let delta = gsap.ticker.deltaRatio(),
            skew = 0

        if (this.scrollSpeed) {
            if (Math.abs(this.scrollSpeed) < 0.05) this.scrollSpeed = 0
            delta += Math.abs(this.scrollSpeed)
            skew = this.getData('speed') * Math.abs(this.scrollSpeed) / 2
        }

        let distance = this.getTranslate(this.$('scrolling')[0]).x + this.getData('speed') * delta

        if (this.getData('speed') < 0 && Math.abs(distance) >= this.$('scrolling')[0].clientWidth / this.getData('duplicate')) {
            distance = 0
        } else if (this.getData('speed') > 0 && distance >= 0) {
            distance = - this.$('scrolling')[0].clientWidth / this.getData('duplicate')
        }

        gsap.set(this.$('scrolling')[0], {x: distance + "px", skewX: skew})
    }

    onScrolling(scrollSpeed) {
        this.scrollSpeed = scrollSpeed
    }

    repeatDom() {
        for (let i = 0; i < parseInt(this.getData('duplicate') - 1); i++) {
            const clone = this.$('content')[0].cloneNode(true)
            this.$('scrolling')[0].appendChild(clone)
        }
    }

    getTranslate(el) {
        const style = window.getComputedStyle(el)
        const matrix = new WebKitCSSMatrix(style.transform)
        return {
            x: matrix.m41,
            y: matrix.m42
        }
    }

    destroy() {
        gsap.ticker.remove(this.addTicker)
    }
}
